module.exports = __webpack_public_path__ + "static/media/Jon Gorman Headshot.657ce66d.jpeg";